import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "PageIntro",
    component: () => (__SERVER__ ? require("./page-intro-view") : import("./page-intro-view"))
});

export default definition;
